import { render, staticRenderFns } from "./DeckCard.vue?vue&type=template&id=4e9fa187&scoped=true&"
import script from "./DeckCard.vue?vue&type=script&lang=js&"
export * from "./DeckCard.vue?vue&type=script&lang=js&"
import style0 from "./DeckCard.vue?vue&type=style&index=0&id=4e9fa187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fa187",
  null
  
)

export default component.exports